import api from "../../api/index";

const usersUrl = `${process.env.VUE_APP_BASE_URI}/users`;

const getDefaultState = () => {
  return {
    users: [],
    status: "",
    meta: {},
  };
};

const state = getDefaultState();

const getters = {
  users: (state) => state.users,
  usersMeta: (state) => state.meta,
};

const actions = {
  async getUsers({ commit }, params) {
    commit("getusers_request");
    const res = await api.get(usersUrl, {params});
    if (res.data.success) {
      commit("getusers_success", res.data.payload);
    }
    return res;
  },
  async addUser({ commit }, newUser) {
    commit("adduser_request");
    const res = await api.post(usersUrl, newUser);
    if (res.data.success) {
      commit("adduser_success");
    }
    return res;
  },

  async editUser({ commit }, { newUser, id }) {
    commit("edituser_request");
    const res = await api.patch(`${usersUrl}/${id}`, newUser);
    if (res.data.success) {
      commit("edituser_success");
    }
    return res;
  },

  async deleteUser({ commit }, id) {
    commit("deleteuser_request");
    const res = await api.delete(`${usersUrl}/${id}`);
    if (res.data.success) {
      commit("deleteuser_success");
    }
    return res;
  },

  async resetUsersState({ commit }) {
    await commit("resetusersstate_success");
  },
};

const mutations = {
  getusers_request: (state) => (state.status = "loading"),
  getusers_success: (state, users) => {
    state.status = "success";
    state.users = users.data;
    state.meta = users.meta;
  },
  adduser_request: (state) => (state.status = "loading"),
  adduser_success: (state) => (state.status = "success"),
  edituser_request: (state) => (state.status = "loading"),
  edituser_success: (state) => (state.status = "success"),
  resetusersstate_success: (state) => Object.assign(state, getDefaultState()),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
